module.exports = __webpack_public_path__ + "static/media/Virtual-mirror-lens-4-psd_Fresh-green-eng.5f77894d.png";